// removed by extract-text-webpack-plugin
module.exports = {"component":"_3ySwq5UkfG86wwRWHUZJT6","summ":"_3PAtuD_Jj1aj1zeqr-eJWJ","sqtxt1":"_2xqG6WcUOOACE2bqpekoCd","sqtxt2":"_1pjZi34vyYXHMAdZAL0odW","jsdd":"_2SWOr-xlkJLlHbuh64cRLl","border":"_3dKMEPrRqv_FPOk3G5tqdn","selt":"_3qdv7AaZ0zvrmMHRn9fcbJ","jsallshou":"_34p-ja1HyxYEd55fLgZ4iO","allTable":"f89T6yNzlN9IaBDiWiLFO","bttn":"_3J_m8W6P77l1gd0PCgKDYC"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyCommissions/MyCommissions.scss
 ** module id = 1073
 ** module chunks = 0
 **/